import { useCallback } from 'react'
import { Box, Typography, Alert, Button } from '@mui/material'
import { LockOutlined as LockIcon } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

export const NotAuthenticated = () => {
  const { t } = useTranslation()

  const handleLogin = useCallback(() => {
    // Trigger authentication flow
    window.location.reload()
  }, [])

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="50vh"
      textAlign="center"
      sx={{ p: 3 }}
    >
      <LockIcon sx={{ fontSize: 60, color: 'warning.main', mb: 2 }} />
      
      <Typography variant="h5" component="h1" gutterBottom sx={{ fontWeight: 500 }}>
        Authentication Required
      </Typography>
      
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3, maxWidth: 400 }}>
        You need to be authenticated to access this application.
      </Typography>

      <Alert severity="warning" sx={{ mb: 3, maxWidth: 400 }}>
        Please log in to continue using the chat application.
      </Alert>

      <Button 
        variant="contained" 
        color="primary" 
        onClick={handleLogin}
        size="large"
        startIcon={<LockIcon />}
      >
        Login
      </Button>
    </Box>
  )
}
